import { Card } from '../types';

// Updated data with projected July 2025 market values based on simulated 100-sale averages from eBay
export const recentHotCards: Card[] = [
  {
    id: '101',
    title: 'Victor Wembanyama 2023 Panini Prizm Rookie Card',
    player: 'Victor Wembanyama',
    team: 'San Antonio Spurs',
    year: 2023,  // Keeping rookie year the same as it's his true rookie
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 950,  // Increased after his dominant 2024-25 sophomore season
    priceChange: 25.7,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Wembanyama+2023+PSA+10',
    description: 'Victor Wembanyama 2023 Panini Prizm Rookie Card in PSA 10 condition. After winning DPOY in his sophomore season, his cards have seen significant value increases.',
    ebayUrl: 'https://www.ebay.com/itm/example101',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '102',
    title: 'Caitlin Clark 2024 Panini Prizm WNBA Rookie Card',
    player: 'Caitlin Clark',
    team: 'Indiana Fever',
    year: 2024,  // Keeping rookie year
    brand: 'Panini Prizm WNBA',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 1200,  // Significant increase due to her continuing impact on WNBA popularity
    priceChange: 32.5,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Clark+2024+PSA+10',
    description: 'Caitlin Clark 2024 Panini Prizm WNBA Rookie Card in PSA 10 condition. Her second season has cemented her as the face of the WNBA, driving record card values.',
    ebayUrl: 'https://www.ebay.com/itm/example102',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '103',
    title: 'Caleb Williams 2024 Panini Prizm Rookie Card',
    player: 'Caleb Williams',
    team: 'Chicago Bears',
    year: 2024,  // Keeping rookie year
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 375,  // Increased after promising rookie season
    priceChange: 15.4,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Williams+2024+Raw',
    description: 'Caleb Williams 2024 Panini Prizm Rookie Card in Near Mint condition. The Bears QB has shown flashes of brilliance in his first full season as a starter.',
    ebayUrl: 'https://www.ebay.com/itm/example103',
    sport: 'football',
    isGraded: false,
  },
  {
    id: '104',
    title: 'Anthony Edwards 2020 Panini Prizm Silver Rookie Card',
    player: 'Anthony Edwards',
    team: 'Minnesota Timberwolves',
    year: 2020,  // Keeping rookie year
    brand: 'Panini Prizm Silver',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 3500,  // Significant increase as he's now considered one of the NBA's top stars
    priceChange: 42.8,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Edwards+2020+PSA+10',
    description: 'Anthony Edwards 2020 Panini Prizm Silver Rookie Card in PSA 10 condition. After leading the Timberwolves to the Western Conference Finals, his cards have surged in value.',
    ebayUrl: 'https://www.ebay.com/itm/example104',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '105',
    title: 'Shohei Ohtani 2025 Topps Chrome Dodgers Card',
    player: 'Shohei Ohtani',
    team: 'Los Angeles Dodgers',
    year: 2025,  // Updated to 2025 release
    brand: 'Topps Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 180,  // Updated for 2025 cards with his return to pitching
    priceChange: 8.3,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Ohtani+2025+PSA+10',
    description: 'Shohei Ohtani 2025 Topps Chrome Los Angeles Dodgers Card in PSA 10 condition. Special edition celebrating his return to two-way play after Tommy John recovery.',
    ebayUrl: 'https://www.ebay.com/itm/example105',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '106',
    title: 'Jayson Tatum 2025 Panini Prizm Championship Card',
    player: 'Jayson Tatum',
    team: 'Boston Celtics',
    year: 2025,  // Updated to 2025 release
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 75,  // Updated for his continued success
    priceChange: -3.8,
    isHot: false,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Tatum+2025+Raw',
    description: 'Jayson Tatum 2025 Panini Prizm Card in Near Mint condition. After back-to-back championship runs with Boston, his cards remain in high demand.',
    ebayUrl: 'https://www.ebay.com/itm/example106',
    sport: 'basketball',
    isGraded: false,
  },
  {
    id: '107',
    title: 'Jayden Daniels 2024 Panini Prizm Rookie Card',
    player: 'Jayden Daniels',
    team: 'Washington Commanders',
    year: 2024,  // Keeping rookie year
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 9',
    price: 425,  // Significant increase after winning Offensive Rookie of the Year
    priceChange: 27.1,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Daniels+2024+PSA+9',
    description: 'Jayden Daniels 2024 Panini Prizm Rookie Card in PSA 9 condition. After an impressive rookie campaign earning him OROY honors, his card values have surged.',
    ebayUrl: 'https://www.ebay.com/itm/example107',
    sport: 'football',
    isGraded: true,
  },
  {
    id: '108',
    title: 'Gunnar Henderson 2023 Topps Chrome Rookie Card',
    player: 'Gunnar Henderson',
    team: 'Baltimore Orioles',
    year: 2023,  // Keeping rookie year
    brand: 'Topps Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 240,  // Increase after continued development with the Orioles
    priceChange: -5.9,
    isHot: false,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Henderson+2023+PSA+10',
    description: 'Gunnar Henderson 2023 Topps Chrome Rookie Card in PSA 10 condition. Now an established star with multiple All-Star appearances for the competitive Orioles.',
    ebayUrl: 'https://www.ebay.com/itm/example108',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '109',
    title: 'Shedeur Sanders 2025 Panini Prizm Rookie Card',
    player: 'Shedeur Sanders',
    team: 'Carolina Panthers',
    year: 2025,  // Updated to his actual NFL rookie year
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 210,  // High rookie demand due to name recognition
    priceChange: 18.6,
    isHot: true,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Sanders+2025+Raw',
    description: 'Shedeur Sanders 2025 Panini Prizm Rookie Card in Near Mint condition. The highly anticipated NFL debut of Coach Prime\'s son has created significant market interest.',
    ebayUrl: 'https://www.ebay.com/itm/example109',
    sport: 'football',
    isGraded: false,
  },
  {
    id: '110',
    title: 'Scottie Scheffler 2025 Upper Deck Golf Card',
    player: 'Scottie Scheffler',
    team: 'PGA Tour',
    year: 2025,  // Updated to 2025 release
    brand: 'Upper Deck',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 220,  // Increase after continued dominance
    priceChange: -1.8,
    isHot: false,
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Scheffler+2025+PSA+10',
    description: 'Scottie Scheffler 2025 Upper Deck Golf Card in PSA 10 condition. After completing a historic season with multiple major wins, his collectibles have seen strong growth.',
    ebayUrl: 'https://www.ebay.com/itm/example110',
    sport: 'baseball', // Using baseball as a placeholder since we don't have a golf category
    isGraded: true,
  },
  {
    id: '111',
    title: 'Luka Doncic 2018 Panini Prizm Rookie Card',
    player: 'Luka Doncic',
    team: 'Dallas Mavericks',
    year: 2018,  // Keeping rookie year
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 2400,  // Substantial increase as he's now a perennial MVP candidate
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Doncic+2018+Raw',
    description: 'Luka Doncic 2018 Panini Prizm Rookie Card in Near Mint condition. After leading Dallas to its first championship since 2011, his rookie cards have skyrocketed in value.',
    ebayUrl: 'https://www.ebay.com/itm/example111',
    sport: 'basketball',
    isGraded: false,
  },
  {
    id: '112',
    title: 'Jackson Holliday 2023 Bowman Chrome Prospect Card',
    player: 'Jackson Holliday',
    team: 'Baltimore Orioles',
    year: 2023,  // Keeping prospect year
    brand: 'Bowman Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 520,  // Increase after successful MLB debut
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Holliday+2023+PSA+10',
    description: 'Jackson Holliday 2023 Bowman Chrome Prospect Card in PSA 10 condition. Now established as one of baseball\'s brightest young stars in Baltimore.',
    ebayUrl: 'https://www.ebay.com/itm/example112',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '113',
    title: 'Nikola Jokić 2015 Panini Prizm Rookie Card',
    player: 'Nikola Jokić',
    team: 'Denver Nuggets',
    year: 2015,  // Keeping rookie year
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 5500,  // Massive increase as he's now considered an all-time great
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Jokic+2015+PSA+10',
    description: 'Nikola Jokić 2015 Panini Prizm Rookie Card in PSA 10 condition. With four MVPs and multiple championships, the Joker has cemented his legacy, driving his rookie card values to new heights.',
    ebayUrl: 'https://www.ebay.com/itm/example113',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '114',
    title: 'Drake Maye 2024 Panini Prizm Rookie Card',
    player: 'Drake Maye',
    team: 'New England Patriots',
    year: 2024,  // Keeping rookie year
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 190,  // Increased after solid rookie season
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Maye+2024+Raw',
    description: 'Drake Maye 2024 Panini Prizm Rookie Card in Near Mint condition. The Patriots QB has shown potential in his development under a new coaching regime.',
    ebayUrl: 'https://www.ebay.com/itm/example114',
    sport: 'football',
    isGraded: false,
  },
  {
    id: '115',
    title: 'Elly De La Cruz 2023 Topps Chrome Rookie Card',
    player: 'Elly De La Cruz',
    team: 'Cincinnati Reds',
    year: 2023,  // Keeping rookie year
    brand: 'Topps Chrome',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 380,  // Significant increase after breakthrough season
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=De+La+Cruz+2023+PSA+10',
    description: 'Elly De La Cruz 2023 Topps Chrome Rookie Card in PSA 10 condition. After a 30/30 season showcasing his unique combination of power and speed, his rookie cards continue to appreciate.',
    ebayUrl: 'https://www.ebay.com/itm/example115',
    sport: 'baseball',
    isGraded: true,
  },
  {
    id: '116',
    title: 'Cooper DeJean 2024 Panini Prizm Rookie Card',
    player: 'Cooper DeJean',
    team: 'Philadelphia Eagles',
    year: 2024,  // Keeping rookie year
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 160,  // Increase after strong defensive rookie season
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=DeJean+2024+Raw',
    description: 'Cooper DeJean 2024 Panini Prizm Rookie Card in Near Mint condition. Has developed into a playmaking defensive back for Philadelphia with a knack for creating turnovers.',
    ebayUrl: 'https://www.ebay.com/itm/example116',
    sport: 'football',
    isGraded: false,
  },
  {
    id: '117',
    title: 'Bronny James 2025 Panini Prizm Rookie Card',
    player: 'Bronny James',
    team: 'Los Angeles Lakers',
    year: 2025,  // New 2025 rookie
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 1800,  // High value due to James family connection
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Bronny+James+2025+PSA+10',
    description: 'Bronny James 2025 Panini Prizm Rookie Card in PSA 10 condition. The historic father-son duo on the Lakers has created unprecedented demand for Bronny\'s rookie cards.',
    ebayUrl: 'https://www.ebay.com/itm/example117',
    sport: 'basketball',
    isGraded: true,
  },
  {
    id: '118',
    title: 'Bryce James 2025 Panini Prizm Rookie Card',
    player: 'Bryce James',
    team: 'Ohio State Buckeyes',
    year: 2025,  // New 2025 college card
    brand: 'Panini Prizm',
    condition: 'Near Mint',
    price: 850,  // High value due to James family connection and NIL
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Bryce+James+2025+Raw',
    description: 'Bryce James 2025 Panini Prizm NIL Ohio State Card in Near Mint condition. The youngest James has generated significant collector interest with his college debut.',
    ebayUrl: 'https://www.ebay.com/itm/example118',
    sport: 'basketball',
    isGraded: false,
  },
  {
    id: '119',
    title: 'Arch Manning 2025 Panini Prizm Texas Card',
    player: 'Arch Manning',
    team: 'Texas Longhorns',
    year: 2025,  // New 2025 college card
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 950,  // High value due to Manning family legacy and college success
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Manning+2025+PSA+10',
    description: 'Arch Manning 2025 Panini Prizm Texas Longhorns Card in PSA 10 condition. The third-generation Manning quarterback has lived up to the family name at Texas.',
    ebayUrl: 'https://www.ebay.com/itm/example119',
    sport: 'football',
    isGraded: true,
  },
  {
    id: '120',
    title: 'Paige Bueckers 2025 Panini Prizm Professional Card',
    player: 'Paige Bueckers',
    team: 'Minnesota Lynx',
    year: 2025,  // New 2025 professional card
    brand: 'Panini Prizm',
    condition: 'Mint',
    grade: 'PSA 10',
    price: 680,  // High value due to popularity and talent
    imageUrl: 'https://via.placeholder.com/300x400/0066cc/ffffff?text=Bueckers+2025+PSA+10',
    description: 'Paige Bueckers 2025 Panini Prizm Rookie Card in PSA 10 condition. Her transition to the WNBA has created significant collector interest in the surging women\'s basketball card market.',
    ebayUrl: 'https://www.ebay.com/itm/example120',
    sport: 'basketball',
    isGraded: true,
  }
]; 